import { useState } from 'react';
import { C } from '../theme/palette';
import { Btn } from './ui/Btn.jsx';
import { _inp } from './ui/Inputs.jsx';

const CHAMPS = [
  ['nom', 'Nom *', 'Nom du client', ''],
  ['adr', 'Rue et n°', 'Adresse du client', 'ex. Rte de la Parraille 7'],
  ['npa', 'NPA et ville', 'NPA et ville du client', 'ex. 1287 Laconnex'],
  ['tel', 'Téléphone', 'Téléphone du client', ''],
  ['email', 'E-mail', 'E-mail du client', ''],
];

/**
 * L'adresse du client choisi, corrigée sur place depuis l'offre ou la facture.
 *
 * <p>Elle ne se changeait que dans la fiche du client, sous « Plus » : une
 * adresse mal reprise des contacts partait telle quelle sur l'offre, sans
 * moyen de la voir ni de la reprendre là où on la remarque. La fiche corrigée
 * est celle du client : ses autres pièces la suivent.
 *
 * @param {object} props propriétés
 * @param {object} [props.client] client choisi, rien n'est montré sans lui
 * @param {(fn: (p: object[]) => object[]) => void} props.setClients mise à jour des clients
 * @returns {import('react').ReactElement|null} l'adresse, son bouton et le formulaire
 */
export function ModifierClient({ client, setClients }) {
  const [fiche, setFiche] = useState(null);
  if (!client) return null;
  const adresse = [client.adr, client.npa].filter(Boolean).join(' · ');

  if (!fiche) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          flexWrap: 'wrap',
          background: C.navyXL,
          borderRadius: 9,
          padding: '8px 10px',
          marginTop: 8,
        }}
      >
        <div style={{ fontSize: 11, color: C.ink, lineHeight: 1.4, minWidth: 0 }}>
          📍 {adresse || 'Aucune adresse'}
        </div>
        <Btn
          label="✎ Modifier l'adresse"
          sm
          ghost
          color={C.navy}
          onClick={() =>
            setFiche({
              nom: client.nom || '',
              adr: client.adr || client.rue || '',
              npa: client.npa || '',
              tel: client.tel || '',
              email: client.email || '',
            })
          }
        />
      </div>
    );
  }

  return (
    <div style={{ border: '1px solid ' + C.border, borderRadius: 10, padding: 12, marginTop: 8 }}>
      <div style={{ fontSize: 11, fontWeight: 800, color: C.navy, marginBottom: 8 }}>
        ✎ Fiche de {client.nom}
      </div>
      {CHAMPS.map(([cle, titre, nom, exemple]) => (
        <div key={cle} style={{ marginBottom: 7 }}>
          <div
            style={{
              fontSize: 9,
              fontWeight: 800,
              color: C.muted,
              textTransform: 'uppercase',
              letterSpacing: 0.4,
              marginBottom: 3,
            }}
          >
            {titre}
          </div>
          <input
            value={fiche[cle]}
            onChange={(e) => setFiche((p) => ({ ...p, [cle]: e.target.value }))}
            placeholder={exemple}
            aria-label={nom}
            style={_inp}
          />
        </div>
      ))}
      <div style={{ display: 'flex', gap: 7 }}>
        <div style={{ flex: 1 }}>
          <Btn label="Annuler" sm ghost color={C.grey} full onClick={() => setFiche(null)} />
        </div>
        <div style={{ flex: 2 }}>
          <Btn
            label="✓ Enregistrer le client"
            sm
            color={C.green}
            full
            disabled={!fiche.nom.trim()}
            onClick={() => {
              const corrige = {
                nom: fiche.nom.trim(),
                adr: fiche.adr.trim(),
                npa: fiche.npa.trim(),
                tel: fiche.tel.trim(),
                email: fiche.email.trim(),
              };
              // La fiche d'entreprise du magasin porte sa rue à part.
              if (client.rue != null) corrige.rue = corrige.adr;
              setClients((p) =>
                (p || []).map((c) => (c.id === client.id ? { ...c, ...corrige } : c)),
              );
              setFiche(null);
            }}
          />
        </div>
      </div>
    </div>
  );
}
